import { useEffect, useState } from 'react';
import { CheckBox } from 'src/Components/Controls';
import { IconButton, Modal } from 'src/Components';
import { SimpleSelect, EnumItemType } from 'src/Components/Controls';
import { Headline } from 'src/UI';
import { IModalProps } from '..';
import { Select2WebElementType } from 'src/Types/ReDoc';
import API from 'src/API';
import '../modals.scss';
import './RedirectModal.scss';

type IRedirectModalProps = IModalProps;

/**
 * Модальное окно перенаправления посетителя
 * Позволяет перенаправить посетителя на другое окно с выбором приоритета
 */
const RedirectModal: React.FC<IRedirectModalProps> = ({
	isOpen,
	onClose,
	onAction,
}) => {
	const [winNumber, setWinNumber] = useState<string | string[]>('');
	const [prior, setPrior] = useState<string | string[]>('Default');
	const [isRedirect, setIsRedirect] = useState<boolean>(false);
	const [stations, setStations] = useState<Array<EnumItemType>>([]);

	/** Загружает список доступных окон при монтировании компонента */
	useEffect(() => {
		API.DamaskEQ.getStations().then((data) => {
			if (!data.hasError) {
				setStations(getEnumsByChoiceses(data.result));
			}
		});
	}, []);

	/** Рендерит содержимое модального окна. Отображает селекты для выбора окна и приоритета, чекбокс для возврата */
	const renderBody: React.FC = (props) => {
		return (
			<div className="modal_wrapper modal_wrapper-redirect">
				<Headline>Выберите номер окна</Headline>
				<SimpleSelect
					isOwnerList
					options={stations}
					value={winNumber}
					setValue={setWinNumber}
					placeholder="Выберите или введите номер окна"
				/>
				<Headline>Выберите приоритет вызова</Headline>
				<SimpleSelect
					isOwnerList
					options={PriorList}
					value={prior}
					setValue={setPrior}
				/>
				<CheckBox
					value={isRedirect}
					setValue={setIsRedirect}
					name="save_acc"
					isBlock
				>
					Заявитель должен вернуться после обслуживания
				</CheckBox>
			</div>
		);
	};

	/** Рендерит панель инструментов модального окна */
	const renderModalToolbar = () => {
		const payload = {
			window: +winNumber,
			priority: prior,
			callback: isRedirect,
		};
		return (
			<>
				<IconButton outline onClick={onClose}>
					Закрыть
				</IconButton>
				<IconButton
					onClick={() => {
						return onAction('redirect', payload);
					}}
				>
					Перенаправить
				</IconButton>
			</>
		);
	};

	return (
		<Modal
			isOpen={isOpen}
			title="Перенаправить посетителя"
			onClose={onClose}
			color="light"
			className="not_scrolled"
			renderFooter={renderModalToolbar()}
			renderBody={renderBody}
		/>
	);
};

/** Список доступных приоритетов перенаправления */
const PriorList: Array<EnumItemType> = [
	{
		id: 'Low',
		title: 'Низкий (разместить в конец очереди)',
	},
	{
		id: 'Default',
		title: 'Cохранить прежний приоритет',
	},
	{
		id: 'High',
		title: 'Высокий (поместить в начало очереди)',
	},
];

/** Преобразует список окон из API в формат для селекта */
const getEnumsByChoiceses = (
	items: Select2WebElementType[],
): Array<EnumItemType> => {
	return items.map((item: Select2WebElementType) => {
		return {
			id: item.id,
			title: item.text || item.id,
		};
	});
};

export default RedirectModal;
